export default __webpack_public_path__ + "static/keith-cascarelli-wtt-d8e29804f33d99613110cdc80a5a96e2.mp4";